const Vision = () => {
  return (
    <section className="vision" style={{ backgroundColor: '#f8f9fa', padding: '4rem 0' }}>
      <div className="container">
        <h2 className="section-title">未来ビジョン</h2>
        <div className="about-content">
          <div className="about-text">
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{ marginBottom: '1rem' }}>ITプロフェッショナルが安心して活躍できる場</h3>
              <p>
                個人として活動するIT人材が、企業所属と同等以上の信用を得られ、
                安心して長く活躍できる環境を整えます。
              </p>
            </div>
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{ marginBottom: '1rem' }}>顧客から信頼される人材の育成と認定</h3>
              <p>
                誠実で高い技術を持つ人材が正しく評価される認定制度を構築し、
                顧客からの信頼を獲得できる仕組みを提供します。
              </p>
            </div>
            <div>
              <h3 style={{ marginBottom: '1rem' }}>日本社会のDX/AX推進に貢献する持続的エコシステム</h3>
              <p>
                現場の人材が継続して進化しつつ活躍することで、
                日本社会全体が望ましい形のDXに進めていけるようにします。
              </p>
            </div>
          </div>
          <div className="about-image">
            <img src="/images/vision_photo_sample.jpg" alt="未来ビジョン" />
          </div>
        </div>
        <div style={{ marginTop: '3rem', padding: '2rem', backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <h3 style={{ marginBottom: '1.5rem', textAlign: 'center' }}>私たちが大切にしていること</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem' }}>
            <div>
              <h4 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>現場主義</h4>
              <p style={{ fontSize: '0.95rem' }}>
                現場の「人」が継続して進化しつつ「活躍」していくことで「社会」全体が望ましい形のDXに進めていける
              </p>
            </div>
            <div>
              <h4 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>信頼の構築</h4>
              <p style={{ fontSize: '0.95rem' }}>
                一人ひとりに相互信用をもたらすために協会自体に信頼を作っていくことを重視
              </p>
            </div>
            <div>
              <h4 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>現場に光を</h4>
              <p style={{ fontSize: '0.95rem' }}>
                現場の人に光があたるような、現場の人が活躍できるような、現場の人が仕事を得られるような身の置き場に
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Vision

